import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { submitSubmission } from '../actions';
import Canvas from './Canvas';

const mapStateToProps = state => ({
  num_questions: state.questions.length,
  submitted: get(state.submission, 'submitted', false),
  next_question: state.next_question
});

const mapDispatchToProp = dispatch => ({
  onSubmit: () => {
    dispatch(submitSubmission());
    window.scrollTo(740,0);
  }
});

class Submit extends React.Component {

  render() {
    const { num_questions, submitted, next_question, onSubmit } = this.props;

    if (submitted || next_question <= num_questions) { return null; }

    return (
      <Canvas spanClass="span6 offset1">
        <center>
          <h2>End of quiz</h2>
          <h3>Please double check your answer.  You will not be able to make any change after you submit.  Whenever you are ready, hit the submit button.</h3> 
          <p>&nbsp;</p>                       
          <button className="btn btn-primary btn-large" type="submit" onClick={ onSubmit } >
            SUBMIT <i className="fa fa-chevron-circle-right" aria-hidden="true" />
          </button>
        </center>
      </Canvas>
    );
  }
}

Submit.propTypes = {
  num_questions: PropTypes.number,
  submitted: PropTypes.bool,
  next_question: PropTypes.number,
  onSubmit: PropTypes.func,
};

const SubmitContainer = connect(
  mapStateToProps,
  mapDispatchToProp
)(Submit);

export default SubmitContainer;


// WEBPACK FOOTER //
// ./src/components/Submit.js